( function () {
    'use strict';
    e.util.galleries = {};
    e.util.galleries.init = function () {
        e.util.galleries.blueimp();
        e.util.galleries.chromatic();
        e.util.galleries.fullscreen.init();
    };
    e.util.galleries.blueimp = function () {
        var jGalleries = jQuery( '.e-gallery' );
        if ( jGalleries.length > 0 ) {
            jGalleries.each( function () {
                var jThis = jQuery( this ),
                    jImageLinks = jThis.find( '.e-gallery-item' ).on( 'click', function ( event ) {
                        event.preventDefault();
                        blueimp.Gallery( jImageLinks.get(), {
                            container: '#blueimp-gallery-' + jThis.data( 'paragraph-id' ),
                            index: jImageLinks.index( this ),
                            thumbnailProperty: 'thumbnail',
                            titleElement: 'p'
                        } );
                        jQuery( '.carousel' ).carousel( 'pause' );
                    } );
            } );
        }
    };
    e.util.galleries.chromatic = function () {
        var jChromatic = jQuery( '.js-e-chromatic' );
        if ( jChromatic.length > 0 ) {
            jChromatic.each( function () {
                var jChromaticGallery = jQuery( this ),
                    jChromaticGalleryItems = jChromaticGallery.find( '.js-e-chromatic-item' ),
                    arrChromaticImages = [];
                jChromaticGalleryItems.each( function () {
                    var jThis = jQuery( this ),
                        jThisImage = jThis.find( '.js-e-chromatic-img' );
                    arrChromaticImages.push( {
                        small: jThisImage.attr( 'src' ),
                        big: jThisImage.data( 'large-src' ),
                        caption: jQuery.trim( jThis.find( '.js-e-chromatic-caption' ).html() )
                    } );
                } );
                jChromaticGallery.empty().chromatic( arrChromaticImages );
            } );
        }
    };
    //lav håndtag til at skifte mellem slide og fade transition
    e.util.galleries.fullscreen = {
        init: function () {
            this.jGallery = jQuery( '.js-e-gallery-fullscreen' ).first();
            if ( this.jGallery.length === 1 ) {
                this.jSlides = this.jGallery.find( '.js-e-gallery-fullscreen-slides > div' );
                this.jControls = this.jGallery.find( '.js-e-gallery-fullscreen-controls > div' );
                this.hideObstructions();
                this.setSizes();
                this.initSlides();
                this.initControls();
                this.bindEvents();
            }
        },
        bindEvents: function () {
            if ( this.jControls.length > 1 ) {
                this.jControls.on( 'mouseenter', function () {
                    var activeIndex = e.util.galleries.fullscreen.jControls.index( this );
                    e.util.galleries.fullscreen.goToSlide( activeIndex );
                } );
            }
            e.constant.jWindow.on( 'resize', function () {
                e.util.galleries.fullscreen.setSizes();
            } );
        },
        initSlides: function () {
            var jThisSlide = this.jSlides.first();
            setTimeout( function () {
                jThisSlide.addClass( 'active' );
            }, 500 ); //TODO: skal være afhængig af controlsEntryInterval
        },
        initControls: function () {
            var controlsEntryInterval = 150; //TODO: flyttes ud i en setting
            setTimeout( function () {
                e.util.galleries.fullscreen.jControls.each( function ( index ) {
                    var jThis = jQuery( this );
                    setTimeout( function () {
                        jThis.removeClass( 'inactive' );
                        if ( index === e.util.galleries.fullscreen.jControls.length - 1 ) {
                            e.util.galleries.fullscreen.goToSlide( 0 );
                        }
                    }, controlsEntryInterval * index - controlsEntryInterval / 4 * index );
                } );
            }, controlsEntryInterval * 5 );
        },
        goToSlide: function ( index ) {
            var jThisControl = this.jControls.eq( index ),
                jThisSlide = this.jSlides.eq( index );
            jThisControl.addClass( 'active' );
            jThisSlide.addClass( 'active' );
            this.jControls.not( jThisControl ).removeClass( 'active' );
            this.jSlides.not( jThisSlide ).removeClass( 'active' );
            clearTimeout( this.shadowSlideTimeout );
            this.shadowSlideTimeout = setTimeout( function () {
                jThisSlide.parent().css( 'background-image', jThisSlide.css( 'background-image' ) );
            }, 750 ); //TODO: bør beregnes udfra øvrige vars
        },
        getVisibleHeight: function () {
            var visibleHeight = e.constant.jWindow.height();
            jQuery( 'body' ).children( 'div' ).filter( ':visible' ).not( '.e-wrapper' ).each( function () {
                var jThis = jQuery( this );
                if ( e.util.isInViewport( jThis ) === true ) {
                    //console.log( jThis.outerHeight(), jThis );
                    visibleHeight = visibleHeight - jThis.outerHeight();
                }
            } );
            return visibleHeight;
        },
        setSizes: function () {
            var jWrapper = jQuery( '.e-wrapper' ),
                visibleHeight = this.getVisibleHeight(),
                pageTop = jWrapper.position().top - 1,
                gutterWidth = 2; //TODO: flyttes ud i en setting
            this.pageWidth = jWrapper.innerWidth();
            jWrapper.css( {
                'margin-top': visibleHeight
            } );
            this.jGallery.css( {
                'position': 'absolute',
                'top': pageTop,
                'padding': 0,
                'height': visibleHeight + 2
            } );
            this.jControls.parent().css( {
                'width': this.pageWidth / 2,
                'margin': '0 auto',

            } );
            if ( this.jControls.length > 1 ) {
                var controlWidth = parseInt( ( this.pageWidth - ( ( this.jControls.length - 1 ) * gutterWidth ) ) / this.jControls.length, 10 );
                this.jControls.each( function ( index ) {
                    jQuery( this ).css( {
                        'width': controlWidth,
                        'left': ( controlWidth * index ) + ( index === 0 ? 0 : gutterWidth * index )
                    } );
                } );
            }
        },
        hideObstructions: function () {
            jQuery( 'body' ).css( 'background-image', 'none' );
            this.jGallery.parents( '.row' ).css( {
                'height': 0,
                'min-height': 0,
                'margin-bottom': 0
            } );
            jQuery( '.js-e-newsletter-popup-teaser, .js-e-newsletter-popup-container, .e-breadcrumb' ).remove();
        }
    };
}() );
